import 'prismjs/plugins/show-invisibles/prism-show-invisibles';
export {
  default as plugin
} from 'prismjs/plugins/show-invisibles/prism-show-invisibles.css';
